var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weixin-tip"},[_c('van-icon',{attrs:{"name":"checked","color":"#07c160"}}),_vm._v(" "),_c('h4',{staticClass:"weui_msg_title"},[_vm._v("微信支付成功")]),_vm._v(" "),_c('van-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.toPayList}},[_vm._v("返回个人中心查看")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12495650","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routerPages/PayResult.vue
// module id = null
// module chunks = 